import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchStates, fetchCities } from "../../../redux/slices/locationSlice";
import Breadcrum from "../../../components/common/Breadcrum";
import Models from "../../../components/common/Models";
import Select from "../../../components/form/Select";
import { selectResponse } from "../../../Helpers/common";
import {
  createCenters,
  getAllCenters,
  editCenters
} from "../../../redux/slices/centersSlice";
import { toast } from "react-toastify";
import Spinner from "../../../components/loader/Spinner";
import BasicTableOne from "../../../components/table/BasicTable";
import axiosInstance from "../../../services/axios";

import Swal from "sweetalert2";
export default function SuperAdminCenter() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [tableRow, setTableRow] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [editData, setEditData] = useState(null);
  const [pageAction, setPageAction] = useState("create");
  const [centerTableLoading, setCenterTableLoading] = useState(false);
  const dispatch = useDispatch();
  const {
    states = [],
    cities = [],
    loading = false,
  } = useSelector((state) => state?.location || {});
  const { centers = [], centerLoading: centerLoading } = useSelector(
    (state) => state?.centers || {}
  );
  const [formData, setFormData] = React.useState({
    name: editData ? editData.name : "",
    state: "",
    city: "",
  });
  // Fetch states when component mounts
  useEffect(() => {
    dispatch(fetchStates());
    dispatch(getAllCenters());
  }, [dispatch]);

  // Fetch cities when state changes
  const handleStateChange = (value) => {
    setFormData((prev) => ({ ...prev, state: value, city: "" }));
    if (value) {
      dispatch(fetchCities(value));
    }
  };

  const breadcrumbItems = [{ label: "Centers", path: "/super-admin/centers" }];

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);
    setIsOpen(false);
    let data = {
      name: formData.name,
      fkstateId: formData.state,
      fkcityId: formData.city,
      status: true,
    };
    try {
      let response;
      if( pageAction === "edit") {
        response = await dispatch(editCenters({ id: formData.id, ...data })).unwrap();
      }else {
         response = await dispatch(createCenters(data)).unwrap();
      }
     
      if (response.status === "success") {
        toast.success(pageAction === "edit" ? "Center updated successfully!" : "Center created successfully!");
        setIsOpen(false);
        setFormData({ name: "", state: "", city: "" }); // Reset form
        if(pageAction === "edit") {
          setTableRow((prevRows) =>
            prevRows.map((row) =>
              row.uuid === formData.id
                ? { ...row, name: formData.name, stateId: formData.state, cityId: formData.city }
                : row
            )
          );
        }
      } else {
        toast.error(pageAction === "edit" ? "Failed to update center" : "Failed to create center");
      }
    } catch (error) {
      toast.error(error.message ?? "Something went wrong");
    }
  };
  useEffect(() => {
    setTableColumns([
      { id: "id", label: "#", type: "text" },
      { id: "name", label: "Center Name", type: "text" },
      { id: "state", label: "State", type: "text" },
      { id: "city", label: "City", type: "text" },
      { id: "status", label: "Status", type: "boolean" },
      {
        id: "action",
        label: "Action",
        type: "action",
        actions: ["edit", "delete"],
      },
    ]);
    setTableRow(centers);
    if (centers.length > 0) {
      const updatedRows = centers.map((center, index) => ({
        id: index + 1,
        name: center.name,
        state: center.state?.name || "N/A",
        city: center.city?.name || "N/A",
        status: center.status,
        cityId: center.fkcityId,
        stateId: center.fkstateId,
        uuid: center.id,
      }));
      setTableRow(updatedRows);
    }
  }, [centers]);
  const handleTableAction = (action, row) => {
    console.log("Action:", action, "Row:", row);

    switch (action) {
      case "edit":
        console.log("Editing row:", row);
        setIsOpen(true);
        setPageAction("edit");
        handleStateChange(row.stateId);
        setFormData({
          name: row ? row.name : "",
          state: row ? row.stateId : "",
          city: row ? row.cityId : "",
          id: row ? row.uuid : "",
        })
        break;
      case "delete":
         Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
        }).then((result) => {
          if (result.isConfirmed) {
            (async () => {
              try {
                setCenterTableLoading(true);
                await axiosInstance.delete(`/centers/${row.uuid}`);
                setTableRow((prevRows) =>
                  prevRows.filter((r) => r.uuid !== row.uuid)
                );
                setCenterTableLoading(false);
              toast.success("Center deleted successfully!");
              } catch (error) {
                setCenterTableLoading(false);
                toast.error(`Failed to delete center: ${error.message}`);
              }
            })();
          }
        });
        break;
      case "view":
        // Navigate to details page
        console.log("Viewing details for:", row); 
        break;
      case "toggleStatus":
        (async () => {
          try {
            await axiosInstance.put(`/centers/${row.uuid}/status`, {
              status: row.status,
            });
            setTableRow((prevRows) =>
              prevRows.map((r) =>
                r.uuid === row.uuid ? { ...r, status: !r.status } : r
              )
            );
            toast.success(`Center status updated successfully!`);
          } catch (error) {
            toast.error(`Failed to update center status: ${error.message}`);
          } 
        })();
        break;
      default:
        console.log("Unhandled action:", action);
    }
  };

  return centerLoading ? (
    <Spinner />
  ) : (
    <>
      <div className="bg-gray-200 dark:bg-gray-800 py-2 px-4 rounded-lg flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-semibold text-theme-dark dark:text-theme-light">
            {breadcrumbItems[0].label}
          </h1>
          <Breadcrum items={breadcrumbItems} />
        </div>
        <div>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="bg-primary-light text-white px-3 py-2 rounded-xl"
          >
            Add New Center
          </button>
        </div>

        <Models isOpen={isOpen} isClose={setIsOpen} name="Add New Center">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-200">
                Center Name
              </label>
              <input
                type="text"
                className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 dark:bg-gray-700 dark:border-gray-600"
                value={formData.name}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, name: e.target.value }))
                }
              />
            </div>

            <Select
              label="State"
              options={selectResponse(states)}
              value={formData.state}
              onChange={handleStateChange}
              isDisabled={loading}
            />

            <Select
              label="City"
              options={selectResponse(cities)}
              value={formData.city}
              onChange={(value) =>
                setFormData((prev) => ({ ...prev, city: value }))
              }
              isDisabled={!formData.state || loading}
            />

            <div className="flex  w-full pt-4">
              <button
                type="submit"
                className="bg-primary-light w-full text-white px-3 py-2 rounded-xl"
              >
                {
                  pageAction === "edit" ? "Update Center" : "Create Center"
                }
              </button>
            </div>
          </form>
        </Models>
      </div>

      <div className="mt-4 ">
        <BasicTableOne
          tableColumns={tableColumns}
          handleTableAction={handleTableAction}
          tableRows={tableRow}
          title="Institute Centers"
          loading={centerTableLoading}
        />
      </div>
    </>
  );
}
